const MOBILE_BREAKPOINT = 768;
const DEVICE_REDIRECT_MARKER = "__lcDeviceRedirect";
const MOBILE_USER_AGENT_RE =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

export function detectLowCodeAccessDevice(environment = {}) {
  const browserNavigator =
    typeof navigator !== "undefined" ? navigator : undefined;
  const browserWindow = typeof window !== "undefined" ? window : undefined;
  const userAgent = String(
    environment.userAgent ?? browserNavigator?.userAgent ?? "",
  );
  const maxTouchPoints = Number(
    environment.maxTouchPoints ?? browserNavigator?.maxTouchPoints ?? 0,
  );
  const viewportWidth = Number(
    environment.viewportWidth ?? browserWindow?.innerWidth ?? MOBILE_BREAKPOINT,
  );

  // iPadOS desktop mode reports itself as Macintosh.
  if (
    MOBILE_USER_AGENT_RE.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)
  ) {
    return "mobile";
  }

  if (/Windows NT|Macintosh|X11|CrOS/i.test(userAgent)) {
    return "desktop";
  }

  return viewportWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop";
}

export function getLowCodeDeviceRedirectTarget(pageInfo, deviceType) {
  if (!pageInfo || typeof pageInfo !== "object") return "";
  const fieldName =
    deviceType === "mobile" ? "mobileRedirectUrl" : "desktopRedirectUrl";
  return String(pageInfo[fieldName] || "").trim();
}

function consumeDeviceRedirectMarker() {
  const currentUrl = new URL(window.location.href);
  if (!currentUrl.searchParams.has(DEVICE_REDIRECT_MARKER)) return false;

  currentUrl.searchParams.delete(DEVICE_REDIRECT_MARKER);
  window.history.replaceState(
    window.history.state,
    "",
    `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`,
  );
  return true;
}

export function buildLowCodeDeviceRedirectUrl(target, currentHref) {
  const rawTarget = String(target || "").trim();
  if (!rawTarget) return "";

  try {
    const currentUrl = new URL(currentHref);
    const targetUrl = new URL(rawTarget, currentUrl);
    if (!/^https?:$/.test(targetUrl.protocol)) return "";

    const comparableCurrentUrl = new URL(currentUrl.href);
    comparableCurrentUrl.searchParams.delete(DEVICE_REDIRECT_MARKER);
    const comparableTargetUrl = new URL(targetUrl.href);
    comparableTargetUrl.searchParams.delete(DEVICE_REDIRECT_MARKER);
    if (comparableCurrentUrl.href === comparableTargetUrl.href) return "";

    targetUrl.searchParams.set(DEVICE_REDIRECT_MARKER, "1");
    return targetUrl.href;
  } catch (_error) {
    return "";
  }
}

export function redirectLowCodePageByDevice(pageInfo) {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  if (consumeDeviceRedirectMarker()) return false;

  const deviceType = detectLowCodeAccessDevice();
  const target = getLowCodeDeviceRedirectTarget(pageInfo, deviceType);
  const redirectUrl = buildLowCodeDeviceRedirectUrl(
    target,
    window.location.href,
  );
  if (!redirectUrl) return false;

  window.location.replace(redirectUrl);
  return true;
}
